import { Dictionary } from "flow/api/types";
import Component from "flow/Component";
import config from "flow/config";
import manifestManager from "flow/utils/manifestManager";

const components: Dictionary<Component> = {};
const instances: Component[] = [];

const fakeRemoveInstance = function () {};

function getComponentByManifest(manifest: any): Component {
    if (manifest.reuseInstance === true) {
        if (components[manifest.id] === undefined) {
            components[manifest.id] = new Component(manifest, fakeRemoveInstance);
        }
        return components[manifest.id];
    }

    const component = new Component(manifest, removeInstance);
    instances.push(component);
    return component;
}

function getComponentById(id: string): Component {
    const manifest = manifestManager.getManifestWithId(id);
    return getComponentByManifest(manifest);
}

function remove(component: Component) {
    if (components[component.manifest.id] !== undefined) {
        components[component.manifest.id] = undefined;
    }

    removeInstance(component);
}

function removeInstance(instance: Component): void {
    const index = instances.indexOf(instance);
    if (index >= 0) {
        instances.splice(index, 1);
    }
}

function getComponents(): Dictionary<Component> {
    return components;
}

function getInstances(): Component[] {
    return instances;
}

function getShadowComponent(): Component {
    let shadowComponent = components[config.componentIds.shadowContainer];
    if (shadowComponent === undefined) {
        const shadowManifest = {
            Id: config.componentIds.shadowContainer,
            Name: "Shadow",
            ViewModelId: "",
            ViewUrl: "",
            isShadow: true,
            order: 99999,
            reuseInstance: true
        };
        shadowComponent = new Component(shadowManifest, fakeRemoveInstance);
        components[config.componentIds.shadowContainer] = shadowComponent;
    }
    return shadowComponent;
}

export default {
    getComponentByManifest: getComponentByManifest,
    getComponentById: getComponentById,
    remove: remove,
    removeInstance: removeInstance,
    getComponents: getComponents,
    getInstances: getInstances,
    getShadowComponent: getShadowComponent
};
